// extracted by mini-css-extract-plugin
export var carrierTab = "_4r-0";
export var carrierTabActive = "_4r-1 _4r-0";
export var carrierTabInactive = "_4r-2 _4r-0";
export var carrierTabLabel = "_4r-3";
export var carrierTabLabelActive = "_4r-4 _4r-3";
export var carrierTabLabelInactive = "_4r-5 _4r-3";
export var carrierTabPercentage = "_4r-6";
export var carrierTabPercentageActive = "_4r-7 _4r-6";
export var carrierTabPercentageInactive = "_4r-8 _4r-6";
export var carrierTabWinnable = "_4r-9";
export var carrierTabWinnableActive = "_4r-a _4r-9";
export var carrierTabWinnableInactive = "_4r-b _4r-9";
export var comparisonContainer = "_4r-d";
export var missingRateButton = "_4r-n";
export var missingRateButtonActive = "_4r-o _4r-n";
export var missingRateButtonInactive = "_4r-p _4r-n";
export var missingRateButtonLabel = "_4r-q";
export var missingRateButtonLabelActive = "_4r-r _4r-q";
export var missingRateButtonLabelInactive = "_4r-s _4r-q";
export var sidebar = "_4r-c";
export var strategyButton = "_4r-e";
export var strategyButtonActive = "_4r-f _4r-e";
export var strategyButtonDescription = "_4r-k";
export var strategyButtonDescriptionActive = "_4r-l _4r-k";
export var strategyButtonDescriptionInactive = "_4r-m _4r-k";
export var strategyButtonInactive = "_4r-g _4r-e";
export var strategyButtonLabel = "_4r-h";
export var strategyButtonLabelActive = "_4r-i _4r-h";
export var strategyButtonLabelInactive = "_4r-j _4r-h";
export var unitToggleButton = "_4r-t";
export var unitToggleButtonActive = "_4r-u _4r-t";
export var unitToggleButtonInactive = "_4r-v _4r-t";
export var unitToggleButtonLabel = "_4r-w";
export var unitToggleButtonLabelActive = "_4r-x _4r-w";
export var unitToggleButtonLabelInactive = "_4r-y _4r-w";